  var csvUrl = '//www.mapir.camera/cdn/shop/files/kernel_filters.csv?v=16256673041791493338';
  var csvString;
  var csvObject;
  var seriesLength = 0;
  
  getCsv(csvUrl);
  handleClickEvents();
  
  function getCsv(url){
    return $.ajax({
      url: url,
      type: 'get',
      dataType: 'text',
      success: function(data){
        csvString = data;
        csvObject = csvToJson(csvString);
      }
    });
  };
   
  function csvToJson(csv){
    var temp = csv.split('\n');
    var columns = temp[0].split(',');
    var json = {};

    for(var i=1; i<columns.length; i++){
      var data = [];
      for(var j=1; j<temp.length; j++){
        var currentColumn = temp[j].split(',')[i] === undefined ? null : parseFloat(temp[j].split(',')[i].trim());
        var currentX = temp[j].split(',')[0] === undefined ? null : parseFloat(temp[j].split(',')[0].trim());
        if(!isNaN(currentColumn)){
          data.push([currentX, currentColumn]);
        }
      }

      json[columns[i].trim()] = {
        name: columns[i].trim(),
        id: columns[i].trim(),
        data: data
      }
    }
    return json;
  };
  
  // This is what draws the chart to the screen
  var filterChart = Highcharts.chart('kernel-filters', {
    title: {
      text: ''
    },
    credits: {
      text: 'www.mapir.camera',
      href: 'https://www.mapir.camera',
      style: {
        fontSize: '12xp'
      }      
    },    
    chart: {
      defaultSeriesType: 'spline'     
    },    
    yAxis: {
      title: {
        text: 'Transmission (%)'
      },
      tickInterval: 5,
      min: 0,
      max: 100
    },
    xAxis: {
      title: {
        text: 'Wavelength (nm)'
      },
      tickInterval: 25,
      min: 200,
      max: 1000,
      gridLineWidth: 1
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'top',
      floating: true
    },
    navigation: {
      buttonOptions: {
        enabled: false
      }
    }, 
    plotOptions: {
      series: {
        marker: {
          enabled: false
        }
      }
    },    
    series: [{
      lineWidth: 1
    }]
  });
  // this removes the empty series created by the initialization of the chart.
  filterChart.series[0].remove();

  function handleClickEvents(){
    addOrRemoveFilter();
    exportButtonAction();
    onChartClear();
  };
  

  function addOrRemoveFilter(){
    $('.filter-toggle').on('change', function(){
      var filterName = $(this).attr('data-filter-name');
      if($(this).prop('checked')){
        filterChart.addSeries(csvObject[filterName]);
      }
      else{
        filterChart.get(filterName).remove();
      }
      seriesLength = filterChart.series.length;
      if(seriesLength){
        $('.clear-chart').prop('disabled', false);
      }
      else{
        $('.clear-chart').prop('disabled', true);      
      }
    });
  };
  
  function onChartClear(){
    $('.clear-chart').on('click', function(event){
      event.preventDefault();
      if(seriesLength){
        resetTogglesAndTriggerClear();
        seriesLength = filterChart.series.length;
        $(this).prop('disabled', true);
      }
      else{
        $(this).prop('disabled', true);
      }
	});    
  };

  
  function resetTogglesAndTriggerClear(){
    $.each($('.filter-toggle'), function(){
      if($(this).prop('checked')){
        $(this).prop('checked', false).trigger('change');
      }
    });
  };


  function exportButtonAction(){
    $('.export').on('click', function(event){
      event.preventDefault();
      var action = event.target.className;
      onExportButtonClick(action);
    });
  };

  function onExportButtonClick(action){
    if(action.indexOf('print-chart')>-1){
      filterChart.print();
    }
    else if(action.indexOf('pdf-chart')>-1){
      filterChart.exportChart({
        type: 'application/pdf',
        filename: 'kernel_filters'
      });    
    }
    else if(action.indexOf('jpeg-chart')>-1){
      filterChart.exportChart({
        type: 'image/jpeg',
        filename: 'kernel_filters'
      });    
    }
    else if(action.indexOf('svg-chart')>-1){
      filterChart.exportChart({
        type: 'image/svg+xml',
        filename: 'kernel_filters'
      });    
    }
  };